<template>
  <div class="container">
    <app-page-search :title="title"></app-page-search>
    <app-spinner v-if="loading"></app-spinner>

    <div v-else class="competencies inner-content">
      <div v-for="block in blocks" v-if="block.categories" :key="block.guid" class="competence-block">
        <div class="competence-block-main">
          <img :src="block.icon_url" alt="" class="competence-block-main__icon">
          <div class="competence-block-main__title">{{ block.title }}</div>
        </div>
        <div class="competence-block-children">
          <router-link
            v-for="competence in block.categories"
            :to="url(block, competence)"
            :key="competence.guid"
            class="competence"
          >
            <div class="competence__code" v-text="competence.code"></div>
            <div class="competence__title" v-text="competence.title"></div>
            <div class="competence__translation" v-text="competence.alt"></div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AppPageSearch, AppSpinner } from "@/components";
import { loadCompetencies } from "@/api/competencies";

export default {
  name: "Competencies",
  components: {
    AppPageSearch,
    AppSpinner
  },

  data: () => ({
    blocks: [],
    title: "Разделы",
    loading: true
  }),
  created() {
    this.loadCompetencies();
  },

  methods: {
    async loadCompetencies() {
      this.blocks = await loadCompetencies();
      this.loading = false;
    },
    url(block, competence) {
      return `/competencies/${block.guid}/categories/${competence.guid}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.loader {
  top: 50%;
}
.competencies {
  padding-top: 50px;
  column-gap: 1.3em;
  column-count: 2;
}

.competence-block {
  margin-bottom: 35px;
  display: inline-block;
  width: 100%;

  .competence-block-main {
    display: flex;

    .competence-block-main__icon {
      min-width: 39px;
      width: 39px;
      height: 38px;
      margin-right: 28px;
    }
    .competence-block-main__title {
      font-size: 20px;
      line-height: 23px;
      font-weight: 500;
      align-self: center;
      color: #000000;
    }
  }

  .competence-block-children {
    margin-top: 15px;

    .competence {
      display: flex;
      font-size: 13px;
      line-height: 30px;
      font-weight: 300;
      cursor: pointer;
      text-decoration: none;
      max-width: fit-content;

      &:hover {
        background-color: #1c3b8d;
        border-radius: 5px;
        margin-left: -10px;
        padding-left: 10px;
        padding-right: 10px;

        .competence__title {
          color: #fff;
        }
        .competence__code,
        .competence__translation {
          color: #6d9ae8;
        }
      }

      .competence__code {
        color: #9c9c9c;
        min-width: 70px;
        font-weight: 500;
      }
      .competence__title {
        margin-right: 10px;
        color: #000;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: fit-content;
      }
      .competence__translation {
        color: #9c9c9c;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
      }
    }
  }
}
@include media-breakpoint-down(md) {
  .competencies {
    column-count: 1;
  }
}

@include media-breakpoint-only(sm) {
  .main-content {
    padding-left: 0;
    padding-right: 0;
  }
}
@include media-breakpoint-down(sm) {
  .competence-block {
    width: 100%;

    .competence-block-children {
      padding-left: 8px;

      .competence {
        line-height: 23px;
        flex-wrap: wrap;

        .competence__title {
          flex: 1 1 69%;
          margin-right: 0;
        }
        .competence__translation {
          margin-left: 70px;
        }
      }
    }
  }
}
</style>
